interface ScoreCircleProps {
  label: string;
  icon: React.ReactNode;
  summary: string;
  isActive?: boolean;
  onClick?: () => void;
}

export const ScoreCircle: React.FC<ScoreCircleProps> = ({
  label,
  icon,
  summary,
  isActive = false,
  onClick,
}) => {
  const isInteractive = !!onClick;
  const Wrapper = isInteractive ? 'button' : 'div';

  return (
    <Wrapper
      {...(isInteractive ? { onClick } : {})}
      className={`
        flex-1 flex flex-col items-center px-5 py-5 transition-all duration-200
        ${isInteractive ? 'cursor-pointer' : ''}
        ${
          isActive
            ? 'bg-teal-50 dark:bg-teal-500/10'
            : isInteractive
              ? 'hover:bg-slate-50 dark:hover:bg-slate-700/20'
              : ''
        }
      `}
    >
      <div
        className={`flex items-center gap-1.5 mb-1.5 ${
          isActive ? 'text-teal-600 dark:text-teal-400' : 'text-secondary'
        }`}
      >
        <span>{icon}</span>
        <span className="text-xs font-semibold tracking-wide uppercase">{label}</span>
      </div>
      <p
        className="text-xs text-center leading-relaxed text-secondary/70"
        style={{ maxWidth: '140px' }}
      >
        {summary}
      </p>
    </Wrapper>
  );
};
